var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,35 C27.3137085,35 30,37.6862915 30,41 C30,44.3137085 27.3137085,47 24,47 C20.6862915,47 18,44.3137085 18,41 C18,37.6862915 20.6862915,35 24,35 Z M24,19 C27.3137085,19 30,21.6862915 30,25 C30,28.3137085 27.3137085,31 24,31 C20.6862915,31 18,28.3137085 18,25 C18,21.6862915 20.6862915,19 24,19 Z M24,3 C27.3137085,3 30,5.6862915 30,9 C30,12.3137085 27.3137085,15 24,15 C20.6862915,15 18,12.3137085 18,9 C18,5.6862915 20.6862915,3 24,3 Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.85777446a1d445e3027a0f69f1bc9e8a.svg";
export { ForwardRef as ReactComponent };